URL_MARKETPLACE_LOGGED_OUT_TEST